import { showAuthDialog, setAuthDialogRedirect } from '@/store/authDialog'
import { clearSession } from '@/store/session'

export default {
  data() {
    return {
      showAuthModal: false
    }
  },
  methods: {
    isAuthError(error) {
      const authMessages = ['登录', '认证', '授权', '过期', '失效', 'token', 'auth', '401', 'unauthorized']
      const message = (error.message || '').toLowerCase()
      return authMessages.some(keyword => message.includes(keyword))
    },
    handleAuthError() {
      this.showAuthModal = false
      setAuthDialogRedirect(this.$route ? this.$route.fullPath : '')
      showAuthDialog({
        message: '登录已失效，请重新登录',
        redirect: this.$route ? this.$route.fullPath : ''
      })
    },
    handleModalClick() {
      // 阻止点击遮罩层关闭弹窗
    },
    handleRelogin() {
      const currentPath = this.$route.fullPath
      clearSession()
      this.$router.replace({
        name: 'login',
        query: { redirect: currentPath }
      }).catch(() => {
        // 忽略导航错误
      })
    }
  }
}
